import React, { useEffect, useState } from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@material-ui/core';
import { GridCloseIcon } from '@mui/x-data-grid';
import { useNotificationContext } from 'features/notification/contexts/NotificationProvider';
import { Notification } from 'features/notification/model/notification';
import { useAppContext } from 'core/contexts';
import styles from './SGSNotification.module.scss';

import { SGSButton } from 'components';
import { radiation } from './radiation';
import { enumStatusCommand } from 'core/services/statusCommand';

interface NotificationQueueProps {}

const NotificationQueue: React.FC<NotificationQueueProps> = () => {
    const { user } = useAppContext();
    const { notification, setNotification, isOpenNotif, setIsOpenNotif, removeNotification } = useNotificationContext();

    const [currentNotification, setCurrentNotification] = useState<Notification | null>(null);

    useEffect(() => {
        const storedNotifications = localStorage.getItem('notificationMessages');
        if (storedNotifications) {
            const parsedNotifications: Notification[] = JSON.parse(storedNotifications);
            if (parsedNotifications.length > 0) {
                setNotification(parsedNotifications);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (notification.length) {
            setCurrentNotification(notification[0]);
            setIsOpenNotif(true);
        }
    }, [notification, setNotification, setIsOpenNotif]);

    const handleClose = (): void => {
        setIsOpenNotif(false);
        removeNotification(0);
    };

    const handleNextNotification = (): void => {
        removeNotification(0);
    };

    function BootstrapDialogTitle(props) {
        const { children, onClose, ...other } = props;

        return (
            <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
                {children}
                {onClose ? (
                    <>
                        {' '}
                        {notification.length > 1 && (
                            <Box
                                className={styles.nbrNotif}
                                style={{
                                    position: 'absolute',
                                    right: 85,
                                    top: 30,
                                    color: '#FFF',
                                }}
                            >
                                ({notification.length} {notification.length > 1 ? 'notifications' : 'notification'})
                            </Box>
                        )}
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                            style={{
                                position: 'absolute',
                                right: 15,
                                top: 20,
                            }}
                        >
                            <GridCloseIcon
                                style={{
                                    position: 'absolute',
                                    right: 15,
                                    top: 15,
                                    color: '#FFF',
                                }}
                            />
                        </IconButton>
                    </>
                ) : null}
            </DialogTitle>
        );
    }

    const loadComponent = (currentNotification) => {
        if (!currentNotification) return;

        switch (currentNotification?.type) {
            case enumStatusCommand.CANCEL_AFFILIE:
                return radiation(currentNotification);
            default:
                throw new Error('Notification component not found');
        }
    };

    return (
        <>
            <Dialog
                open={isOpenNotif && user.token && currentNotification !== null}
                onClose={handleClose}
                maxWidth="md"
                PaperProps={{
                    style: { width: '100%', maxHeight: '80vh', borderRadius: 10 },
                }}
            >
                <BootstrapDialogTitle onClose={handleClose} className={styles.header}>
                    <span className={styles.header__text}>{currentNotification?.title}</span>
                </BootstrapDialogTitle>
                <DialogContent>
                    <DialogContentText className="m-2" style={{ minHeight: '81px', width: '98%' }}>
                        {loadComponent(currentNotification)}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="mr-2 mb-2 mt-4 mb-4" style={{ minHeight: '59px' }}>
                    <Box className="text-center w-100">
                        {notification.length > 1 ? (
                            <SGSButton onClick={handleNextNotification} className={styles.BtnBlue}>
                                Message suivant
                            </SGSButton>
                        ) : (
                            <SGSButton onClick={handleClose} className={styles.BtnBlue}>
                                J'ai compris
                            </SGSButton>
                        )}
                    </Box>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default NotificationQueue;
